
import { C } from '../constants/theme';
import MobileCard from './MobileCard';
import MobileMoneyRow from './MobileMoneyRow';

/**
 * Two small facts-on-a-phone pieces, shared by every screen that shows a figure
 * above a list or a label/value line inside a detail sheet.
 *
 * Both were invented inside «عملیات و هزینه» and promoted when that screen split
 * into «مدیریت هزینه‌ها» and «کالاها و خدمات»
 * (docs/CLINIC_EXPENSES_AND_GOODS_SPLIT_DESIGN.md): two copies of a KPI tile is
 * how one page ends up with a tappable figure and the other with a dead one.
 * Layer 3 of `src/mobile/` — layout opinion, imported only by `*.mobile.jsx`.
 */

/**
 * One money fact, tappable when it leads somewhere.
 *
 * `MobileMoneyRow` draws the figure; the card around it is what makes «در
 * انتظار تأیید» a way INTO the queue rather than a number to read and then go
 * looking for. A row that leads nowhere is rendered as a plain row, because a
 * control that cannot resolve teaches people not to tap (MOBILE §2.4 rule 5).
 */
export function MobileMoneyTile({ label, value, hint, tone, onClick, testid }) {
  return (
    <MobileCard
      onClick={onClick}
      label={label}
      tone={tone === 'warn' ? C.amberLight : undefined}
      data-testid={testid}
      style={{ padding: '0.75rem 0.875rem' }}
    >
      <MobileMoneyRow label={label} value={value} hint={hint} tone={tone} />
    </MobileCard>
  );
}

/** A label/value line inside a detail sheet. */
export function MobileDetailRow({ label, value }) {
  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', gap: '0.75rem',
      padding: '0.5rem 0', borderBottom: `1px solid ${C.border}`, fontSize: '0.8125rem',
    }}>
      <span style={{ color: C.textMuted }}>{label}</span>
      <span dir="auto" style={{ color: C.textPrimary, fontWeight: 600, textAlign: 'end' }}>{value}</span>
    </div>
  );
}
